import React from 'react';

import Row from '../components/row';
import Title from '../components/title';
import Section from '../components/section';

import JuniorSuite from './junior-suite/images/junior.1.jpg';
import Standard from './standard/images/Standard.13.jpg';
import StandardGarden from './standard-garden/images/garden.8.jpg';
import Superior from './superior/images/Superior.13.jpg';
import TripleSuperior from './triple-superior/images/triple-superior.6.jpg';
import SuperiorFamiliar from './superior-familiar/images/familiar-superior.jpg';
import Loft from './loft/images/Loft.2.jpg';


const Rooms = () => {
  return (
    <Row>
      <Title title="Nuestras habitaciones" />
      <Section url="/rooms/junior-suite" index={0} first img={JuniorSuite} title="Junior Suite">
        <p className="p-services">Con una pequeña kitchenette para hacer mas cómoda su estadia.</p>
      </Section>
      <Section url="/rooms/standard" index={0} img={Standard} title="Standard">
        <p className="p-services">Ubicadas alrededor de nuestro patio interno.</p>
      </Section>
      <Section url="/rooms/standard-garden" index={0} img={StandardGarden} title="Standard Garden">
        <p className="p-services">Ubicadas frente a la piscina.</p>
      </Section>
      <Section url="/rooms/superior" index={0} img={Superior} title="Superior">
        <p className="p-services">Distribuidas en todos los sectores del hotel.</p>
      </Section>
      <Section url="/rooms/triple-superior" index={0} img={TripleSuperior} title="Triple Superior">
        <p className="p-services">Cómoda habitación con vistas a la calle en formato twin o matrimonial + cama.</p>
      </Section>
      <Section url="/rooms/superior-familiar" index={0} img={SuperiorFamiliar} title="Superior Familiar">
        <p className="p-services">Creada para alojar una familia.</p>
      </Section>
      <Section url="/rooms/loft" index={0} img={Loft} title="Loft">
        <p className="p-services">Diseñado con un concepto moderno y minimalista.</p>
      </Section>
    </Row>
  )
}

export default Rooms;



// WEBPACK FOOTER //
// ./src/rooms/index.js